// src/plugins/platform.js
import { getPlatform } from '@/utils/platform'

export const installPlatform = (Vue) => {
  const platformInfo = getPlatform()

  // Stable snapshot for the whole session
  Vue.prototype.$platform = platformInfo
  Vue.prototype.$isNativeApp = platformInfo.isWebView
}